var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classNames from 'classnames';
import usePrefixCls from '../hooks/usePrefixCls';
import { ChevronRightIcon } from '../icon';
import AntdDropdown from './AntdDropdown';
const { Button } = AntdDropdown;
const BaseDropdown = React.forwardRef((_a, ref) => {
    var { size = 'middle', className, overlayClassName, prefixCls: customizePrefixCls } = _a, rest = __rest(_a, ["size", "className", "overlayClassName", "prefixCls"]);
    const prefixCls = usePrefixCls('dropdown', customizePrefixCls);
    return (React.createElement(AntdDropdown, Object.assign({ className: classNames(prefixCls, { [`${prefixCls}-${size}`]: size }, className), overlayClassName: classNames(`${prefixCls}-overlay`, { [`${prefixCls}-overlay-${size}`]: size !== 'middle' }, overlayClassName), ref: ref, arrowIcon: React.createElement(ChevronRightIcon, null) }, rest)));
});
const BaseDropdownButton = (_a) => {
    var { className, overlayClassName, prefixCls: customizePrefixCls, size = 'middle' } = _a, rest = __rest(_a, ["className", "overlayClassName", "prefixCls", "size"]);
    const prefixCls = usePrefixCls('dropdown', customizePrefixCls);
    return (React.createElement(Button, Object.assign({ className: classNames(`${prefixCls}-button`, className), overlayClassName: classNames(`${prefixCls}-overlay`, { [`${prefixCls}-overlay-${size}`]: size !== 'middle' }, overlayClassName), arrowIcon: React.createElement(ChevronRightIcon, null) }, rest)));
};
const Dropdown = BaseDropdown;
Dropdown.Button = BaseDropdownButton;
export default Dropdown;
